import { NewsletterSectionRow, TableWrapper } from './helpersComponents'
import { headlineLargeBold, headlineMediumBold } from './helpersTypo'
import NewsletterContentText from './NewsletterContentText'

const NewsletterSectionTextLines = ({stylesData, closingTextLines}) => {
    const chosenFont = stylesData.chosenFont
    const colorText = stylesData.secText

    return (
        Array.isArray(closingTextLines) && closingTextLines.length > 0 ? [
            <NewsletterSectionRow key="closing-section">
                <TableWrapper>
                    {closingTextLines.map(({newsletter_closing_formula_line}, index) => (
                        <tr key={index + 'text'}>
                            <NewsletterContentText>
                                {0 === index ? [
                                    <p key={'first-line'} style={{...{color: colorText, margin: 0, textAlign: 'center', paddingTop: "20px"}, ...headlineLargeBold(chosenFont)}}>{newsletter_closing_formula_line}</p>
                                ]:[
                                    <p key={index + '-line'} style={{...{color: colorText, margin: 0, textAlign: 'center', paddingTop: "12px"}, ...headlineMediumBold(chosenFont)}}>{newsletter_closing_formula_line}</p>
                                ]}
                            </NewsletterContentText>
                        </tr>
                        )
                    )}
                </TableWrapper>
            </NewsletterSectionRow>
        ] : null
    )
}

export default NewsletterSectionTextLines